module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loseDataEcharts"
    }
  }, [_c('div', {
    ref: "progressEcharts",
    attrs: {
      "id": "progressEcharts"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "PieEchartsBox"
  }, [_c('div', {
    ref: "PieEcharts",
    attrs: {
      "id": "PieEcharts"
    }
  }), _vm._v(" "), (_vm.Judge) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f7a6c01"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportComponent/loseDataEcharts.vue
// module id = 1654
// module chunks = 471